module.exports = __webpack_public_path__ + "static/img/logo.2433fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/User/logo.png
// module id = 5VSF
// module chunks = 4